import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "email", "password", "submitButton", "forgotPasswordLink", "backToLoginLink", "passwordField", "rememberMeField"]

  connect() {
    this.isResetMode = false
  }

  toggleMode(event) {
    event.preventDefault()
    this.isResetMode = !this.isResetMode

    if (this.isResetMode) {
      this.passwordFieldTarget.classList.add("hidden")
      this.rememberMeFieldTarget.classList.add("hidden")
      this.submitButtonTarget.textContent = "Send reset email"
      this.forgotPasswordLinkTarget.classList.add("hidden")
      this.backToLoginLinkTarget.classList.remove("hidden")
      this.formTarget.action = "/request_password_reset"
      // Clear any existing flash messages
      const existingFlash = this.formTarget.querySelector('.bg-red-100, .bg-green-100')
      if (existingFlash) existingFlash.remove()
    } else {
      this.passwordFieldTarget.classList.remove("hidden")
      this.rememberMeFieldTarget.classList.remove("hidden")
      this.submitButtonTarget.textContent = "Login"
      this.forgotPasswordLinkTarget.classList.remove("hidden")
      this.backToLoginLinkTarget.classList.add("hidden")
      this.formTarget.action = "/user_session"
      // Clear any existing flash messages
      const existingFlash = this.formTarget.querySelector('.bg-red-100, .bg-green-100')
      if (existingFlash) existingFlash.remove()
    }
  }

  async submit(event) {
    event.preventDefault()

    if (this.isResetMode) {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      try {
        const response = await fetch(this.formTarget.action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            email: this.emailTarget.value
          })
        })

        const data = await response.json()

        if (response.ok) {
          // Show success message
          const flashDiv = document.createElement('div')
          flashDiv.className = 'mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg'
          flashDiv.innerHTML = `
            <div class="flex items-center">
              <iconify-icon icon="ph:check-circle" class="text-xl mr-2"></iconify-icon>
              <span>${data.message}</span>
            </div>
          `
          this.formTarget.insertBefore(flashDiv, this.formTarget.firstChild)
          
          // Clear any existing error messages
          const existingError = this.formTarget.querySelector('.bg-red-100')
          if (existingError) existingError.remove()
        } else {
          // Show error message
          const flashDiv = document.createElement('div')
          flashDiv.className = 'mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg'
          flashDiv.innerHTML = `
            <div class="flex items-center">
              <iconify-icon icon="ph:x-circle" class="text-xl mr-2"></iconify-icon>
              <span>${data.error}</span>
            </div>
          `
          this.formTarget.insertBefore(flashDiv, this.formTarget.firstChild)
        }
      } catch (error) {
        console.error('Error:', error)
        // Show error message
        const flashDiv = document.createElement('div')
        flashDiv.className = 'mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg'
        flashDiv.innerHTML = `
          <div class="flex items-center">
            <iconify-icon icon="ph:x-circle" class="text-xl mr-2"></iconify-icon>
            <span>An error occurred. Please try again.</span>
          </div>
        `
        this.formTarget.insertBefore(flashDiv, this.formTarget.firstChild)
      }
    } else {
      this.formTarget.submit()
    }
  }
} 